/**
 * API for managing allowed sellers for a buyer campaign
 * Base URL: /api/v1/review/traffic/buyer-campaign
 */
import { AxiosInstance, AxiosResponse } from 'axios'
import createHttpClient from './httpClient'
import { AllowedSellersResponse } from '@/store/campaign-traffic-control'

const baseUrl = new URL('/api/v1/review/traffic/buyer-campaign', process.env.VUE_APP_INTERNAL_SERVICE_BASE_URL).href
const httpClient: AxiosInstance = createHttpClient(baseUrl)

const BuyerCampaignTrafficControlAPI = {
  /**
   * Get allowed sellers for a buyer campaign
   *
   * @route GET traffic/buyer-campaign/{buyerCampaignId}
   * @param buyerCampaignId - The ID of the buyer campaign
   * @returns Response with allowed sellers and source information
   */
  async getAllowedSellers(buyerCampaignId: string): Promise<AxiosResponse<AllowedSellersResponse>> {
    return await httpClient.get<AllowedSellersResponse>(`${buyerCampaignId}`)
  },

  /**
   * Set allowed sellers for a buyer campaign
   *
   * @route POST traffic/buyer-campaign/{buyerCampaignId}
   * @param buyerCampaignId - The ID of the buyer campaign
   * @param sellerIds - List of seller IDs to allow (empty array means allow all sellers)
   * @returns Response with 200 status code (no data)
   */
  async setAllowedSellers(
    buyerCampaignId: string,
    sellerIds: string[]
  ): Promise<AxiosResponse<void>> {
    return await httpClient.post<void>(`${buyerCampaignId}`, sellerIds)
  }
}

export default BuyerCampaignTrafficControlAPI
